import { AuctionStatusEnum } from "../_common/enum/auctionStatus.enum";
import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";
import { getQuery } from "../_helpers/query.helper";

const API_NAME = "auction";

export const auctionService = {
    getActive,
    setStatus,
    activate,
    startAnnual,
    getAnnualState,
    getAnnualTurnHistory,
    completeAnnualTurn,
    advanceAnnualTurn,
};

function getActive() {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetActive`, requestOptions).then(handleResponse);
}

function setStatus(auctionId: number, auctionStatusId: AuctionStatusEnum) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody({ auctionId: auctionId, auctionStatusId: auctionStatusId }) };
    return fetch(`${API_URL}/${API_NAME}/setStatus`, requestOptions).then(handleResponse);
}

function activate(auctionId: number) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody({ auctionId: auctionId, auctionStatusId: AuctionStatusEnum.Pending }) };
    return fetch(`${API_URL}/${API_NAME}/activate`, requestOptions).then(handleResponse);
}

function startAnnual(auctionId: number) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody({ auctionId: auctionId, auctionStatusId: AuctionStatusEnum.Pending }) };
    return fetch(`${API_URL}/${API_NAME}/startAnnual`, requestOptions).then(handleResponse);
}

function getAnnualState(auctionId: number, onBehalfCatalogueUserId?: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    const onBehalf = onBehalfCatalogueUserId && onBehalfCatalogueUserId > 0 ? `&onBehalfCatalogueUserId=${onBehalfCatalogueUserId}` : '';
    return fetch(`${API_URL}/${API_NAME}/GetAnnualState?auctionId=${auctionId}${onBehalf}`, requestOptions).then(handleResponse);
}

function getAnnualTurnHistory(auctionId: number, onBehalfCatalogueUserId?: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    const onBehalf = onBehalfCatalogueUserId && onBehalfCatalogueUserId > 0 ? `&onBehalfCatalogueUserId=${onBehalfCatalogueUserId}` : '';
    return fetch(`${API_URL}/${API_NAME}/GetAnnualTurnHistory?auctionId=${auctionId}${onBehalf}`, requestOptions).then(handleResponse);
}

function completeAnnualTurn(auctionId: number, currentCatalogueUserId: number, selectedCatalogueItemIds: number[]) {
    const requestOptions = {
        method: 'PUT',
        headers: getHeader(),
        body: getBody({ auctionId, currentCatalogueUserId, selectedCatalogueItemIds }),
    };
    return fetch(`${API_URL}/${API_NAME}/CompleteAnnualTurn`, requestOptions).then(handleResponse);
}

function advanceAnnualTurn(auctionId: number, action: 1 | 2 | 3) {
    const requestOptions = {
        method: 'PUT',
        headers: getHeader(),
        body: getBody({ auctionId, action }),
    };
    return fetch(`${API_URL}/${API_NAME}/AdvanceAnnualTurn`, requestOptions).then(handleResponse);
}